import dynamic from 'next/dynamic';

export const VerifiedSpecialRatesEditable = dynamic(() =>
  import('./VerifiedSpecialRates').then(mod => mod.VerifiedSpecialRatesEditable)
);
